import request from '@/utils/request'

// 获取账户记录的枚举
export function accountTypeListApi() {
  return request.get('/record/accountTypeList')
}

// 账户流水日志
export function accountListApi(data) {
  return request.post('/record/accountList', data)
}

//  -------------------------------

// 获取下注枚举
export function recordsEnumsApi() {
  return request.get('/v1/records/enums')
}

// 获取下注记录
export function recordsBetApi(params) {
  return request.get('/v1/records/bet', {
    params,
  })
}

// 获取下注报告(周亏损)
export function betReportApi(params) {
  return request.get('/v1/records/betReport', {
    params,
  })
}

// 获取充值记录
export function rechargeOrderListApi(data) {
  return request.post('/transfer/rechargeOrderList', data)
}
